<template>
	<header class="page-crumb-header-layout">
		<div class="segment">
			<BackButton
				:disabled="disabled"
				@click="$emit( `back` )"
			/>
		</div>
		<div class="segment title-segment">
			<div class="breadcrumbs" v-if="crumbs.length">
				<Breadcrumbs
					:crumbs="crumbs"
					:disabled="disabled"
					@activate="onBreadcrumbActivate"
				/>
			</div>
			<slot name="body">
				<h1 class="title-text text-truncate">
					<slot name="title"></slot>
				</h1>
			</slot>
		</div>
	</header>
</template>

<script>
import Breadcrumbs from "../components/Breadcrumbs";
import BackButton from "../components/buttons/BackButton.vue";

/**
 * PageCrumbHeaderLayout
 *
 * Breadcrumb layout for a full page header component, divided into two slots:
 * - title
 * - right
 *
 * Applies mobile styles at mobile breakpoints to center title at mobile resolutions.
 */
export default {
	name: "PageCrumbHeaderLayout",
	emits: [ "back", "crumb", ],
	components: {
		Breadcrumbs,
		BackButton,
	},
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		/** [ { text:String, route:String, isActive:Boolean, }, ... ] */
		crumbs: {
			type: Array,
			required: true,
		},
	},
	methods: {
		onBreadcrumbActivate( crumb ) {
			this.$emit( "crumb", crumb );
		},
	},
};
</script>

<style lang="scss" scoped>
$pageCrumbHeaderLayoutTitleColor: $color1-700;
$pageCrumbHeaderLayoutBorderColor: $color1-200;

.page-crumb-header-layout {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	gap: 1rem;
	padding: 1rem;
	border-bottom: 0.0625rem solid $pageCrumbHeaderLayoutBorderColor;

	@include for-size('md') {
		padding: 1.5rem;
	}
}

.page-crumb-header-layout .title-text {
	@include font-and-line-for(2);
	color: $pageCrumbHeaderLayoutTitleColor;
	font-weight: 700;
	text-align: left;

	width: 100%;
}

.page-crumb-header-layout .segment {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	gap: 0.2rem;
}

.page-crumb-header-layout .segment.title-segment {
	flex: 1;

	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;

	overflow-x: hidden;
}
</style>
